import React from 'react';
import { Icon } from '../icon';
import classNames from 'classnames';
// @NOTE: to suppress error TS4082: Default export of the module has or is using private name
import AntdSearch from 'antd/es/input/Search';
import { ConfigContext } from '../config-provider';
import { getInputClassNames } from './Input';
import warning from 'antd/es/_util/warning';
import AntdConfigProvider from 'antd/es/config-provider';
import AnimationContext from '../config-provider/AnimationContext';
const Search = React.forwardRef((props, ref) => {
    const { className, suffix, size, ...otherProps } = props;
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('input', props.prefixCls);
    const animation = React.useContext(AnimationContext);
    const customClassName = getInputClassNames(props, !!animation?.breathing, prefixCls);
    const mergedClassnames = classNames(customClassName, {
        [`${prefixCls}-group-wrapper-xs`]: size === 'xs',
        [`${prefixCls}-group-wrapper-borderless`]: otherProps.bordered === false
    });
    if (size !== 'xs') {
        otherProps.size = props.size;
    }
    if (process.env.NODE_ENV !== 'production')
        warning(props.bordered !== false, 'input.search', `'bordered = false' is deprecated now`);
    otherProps.bordered = true;
    warning(props.theme !== 'gray', 'input.search', `'themes = gray' is deprecated now`);
    return (React.createElement(AntdConfigProvider, { prefixCls: getPrefixCls('', props.prefixCls), ...restContext },
        React.createElement(AntdSearch, { enterButton: suffix, ...otherProps, className: mergedClassnames, ref: ref })));
});
Search.defaultProps = {
    suffix: React.createElement(Icon, { type: 'search' })
};
Search.displayName = 'Search';
// export default withConfigProvider(Search);
export default Search;
